import React from 'react'
import { useHistory } from 'react-router-dom'
import { RiSettings5Fill, RiNotification2Fill } from 'react-icons/ri'
import Account from '@material-ui/icons/AccountCircle';
import routes from '../../services/Routes'
import './headercomponent.css'
import Tooltip from '@material-ui/core/Tooltip';
import { Typography, Button, Grid } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Moment from 'moment'
import moment from 'moment-timezone'
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { BsPeopleFill } from "react-icons/bs";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { alpha } from '@material-ui/core/styles'
import Modal from '../../components/PopUpModal/Modal'
import Backdrop from '../../components/PopUpModal/Backdrop'
import jwt_decode from "jwt-decode";
import { BiLogOut } from 'react-icons/bi'
import CryptoJS from 'crypto-js';
import * as userActionCreators from '../../store/Actions/Authentication-creator'
import { useDispatch } from 'react-redux'

function HeaderComponent(props: any) {
    const [title, setTitle] = React.useState('')
    const history = useHistory();
    const dipatch = useDispatch()
    const [user, setUser] = React.useState<any>({})
    const [logoutModal, setLogoutModal] = React.useState(false)
    const [data, setData] = React.useState<any>({})
    const { location } = useHistory()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
    };

    React.useEffect(() => {
        let route_check = routes.filter(route => route.path === location.pathname);

        if (route_check.length) {
            setTitle(route_check[0].Title)
        }
        else {
            setTitle("")
        }
        // routes.forEach((route: any) => {
        //     if (route.path === location.pathname) {
        //         setTitle(route.Title)
        //     }
        // })
    }, [location.pathname])



    React.useEffect(() => {

        var data = localStorage.getItem("user")
        var newData = data ? JSON.parse(data) : ""
        setUser(newData)

    }, [])

    const handlePopup = () => {
        setAnchorEl(null);
        setLogoutModal(!logoutModal)
    }

    const handleChangelogoutModal = (data: any) => {
        setLogoutModal(!logoutModal)
    }


    const token = Object.keys(user).length && user.access ? user.access.token : null;

    React.useEffect(() => {
        if (token) {
            const decodedHeader: any = jwt_decode(token);
            if (decodedHeader?.key) {
                const decryptData2 = (encryptedData: any) => {
                    var C = CryptoJS;
                    var Key = C.enc.Utf8.parse("oSOhgvKFi2AbgyVwtKMKwFV8pSc5kyxU");
                    var IV = C.enc.Utf8.parse("oSOhgvKFi2AbgyVw");
                    var decryptedText = C.AES.decrypt(encryptedData, Key, {
                        iv: IV,
                        mode: C.mode.CBC,
                        padding: C.pad.Pkcs7
                    });
                    return decryptedText.toString(CryptoJS.enc.Utf8);
                }
                const userData = JSON.parse(decryptData2(decodedHeader?.key)) ? JSON.parse(decryptData2(decodedHeader?.key)) : ""
                dipatch(userActionCreators.initUserData({ userData: userData }))
                setData(userData)

            }

        }
    }, [token])


    var torent_current_time = moment().tz("America/Toronto").format('YYYY MMM DD hh:mm A')

    return (
        <div className="header_component_section">
            {
                logoutModal && (
                    <>
                        <Backdrop handlePopupModal={handleChangelogoutModal} />
                        <Modal
                            title="Are you sure you want to logout?"
                            handlePopupModal={handleChangelogoutModal}
                        // breakLine={false}
                        >
                            <Grid container spacing={2} style={{ marginBottom: '15px' }}>
                                <Grid item md={12} style={{ textAlign: "center" }}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            marginTop: 5,
                                            marginRight: 12,
                                            background: " #3A416F",
                                            border: "0.791301px solid #3A416F",
                                            color: "#FFFFFF",
                                            fontFamily: "Work Sans",
                                            fontStyle: "normal",
                                            fontWeight: "bold",
                                            textTransform: "capitalize",
                                            fontSize: 12,
                                            padding: "5px 20px",
                                            borderRadius: "4.7478px"
                                        }}
                                        onClick={() => history.push('/logout')}
                                    //onClick={() => onClickdeleteCallAddon(deleteId)}
                                    >
                                        Yes</Button>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            fontFamily: "Work Sans",
                                            fontStyle: "normal",
                                            fontWeight: "bold",
                                            textTransform: "capitalize",
                                            fontSize: 12,
                                            color: "#8392AB",
                                            border: "0.791301px solid #8392AB",
                                            background: "#F5F5F5",
                                            padding: "6px 20px",
                                            borderRadius: "4.7478px",
                                            marginLeft: 10,
                                            marginTop: 5,
                                        }}
                                        onClick={handleChangelogoutModal}>No</Button>
                                </Grid>
                            </Grid>
                        </Modal>
                    </>
                )
            }
            <div className="right_side_header">
                <div className="date_time_section">
                    <p>{torent_current_time}</p>
                </div>
                {/* <div className="user_profile_section">
                    <Account style={{ color: '#67748E' }} />
                    <p>{data.firstName}</p>
                </div> */}
                <div>
                    <Button
                        id="basic-button"
                        aria-controls="basic-menu"
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        style={{ textTransform: "initial" }}
                    >
                        {data.firstName}
                    </Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handlePopup}>
                            <ListItemIcon>
                                <BiLogOut size={21} color="grey" />
                            </ListItemIcon>
                            <ListItemText>Logout</ListItemText>
                        </MenuItem>
                    </Menu>
                </div>
                {/* <div className="header_user_controller">
                    <RiSettings5Fill size={22} color="#67748E" />
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                        <RiNotification2Fill size={21} color="#67748E" />
                        <div className="noti-symbol">4</div>
                    </div>
                </div> */}
            </div>
            <div className="left_side_header">
                {/* <p>Pages / <span className="header_compo_title">{title}</span></p> */}
                <p className="main_header_title">{title}</p>
            </div>
        </div>
    )
}


export default HeaderComponent
